<!-- eslint-disable vue/no-v-html -->
<template>
  <!-- Add div container. TO DO: add space in children element after Nuxt 3 release is stable -->
  <div v-if="event">
    <konkatsu-freepass
      v-if="konkatsuFreepass"
      :event="event"
      :purchase-status="purchaseStatus"
      :tickets="konkatsuFreepassTickets"
      :is-past-event="isPastEvent"
    />
    <menpass v-else-if="mensPass" :event="event" :purchase-status="purchaseStatus" :ticket-id="mensPassTicketId" />
    <online-fitness-pass
      v-else-if="onlineFitnessPass"
      :event="event"
      :purchase-status="purchaseStatus"
      :ticket="ticketInfo.tickets[0]"
      :disable-button="disablePurchaseButton"
      :loaded-latest-ticket-info="loadedLatestTicketInfo"
      :videos="videos"
      :room1-url="room1Url"
      :room2-url="room2Url"
      :support-room-link="supportRoomLink"
      :video-setting-support-link="videoSettingSupportLink"
      :communication-room-link="communicationRoomLink"
      :button-text="filteredTicketInfo ? ticketInfo.fixed_ticket_button_message : ''"
    />
    <online-cafetalk-yoga-pass
      v-else-if="onlineCafetalkYogaPass"
      :event="event"
      :purchase-status="purchaseStatus"
      :ticket="ticketInfo.tickets[0]"
      :disable-button="disablePurchaseButton"
      :loaded-latest-ticket-info="loadedLatestTicketInfo"
      :button-text="filteredTicketInfo ? ticketInfo.fixed_ticket_button_message : ''"
      :schedule="schedule"
    />
    <div v-else>
      <div>
        <div class="container">
          <div class="container-main">
            <common-flash-message :no-margin="true" />
            <notification-message v-if="headerInformationsForEventDetail" :header-informations="headerInformationsForEventDetail" />
            <div v-if="pageDetector.isEventPreviewPage" class="marginB3">
              <flash-message :message="$useI18('event.messages.preview')" type="error" />
            </div>
            <template v-if="displayEventStatusFlashMessage">
              <div :class="{ 'paddingT4 paddingB4': $store.isSP }" class="flash-message">
                <h2 :class="$store.isSP ? 'paddingL0 commonHeadingBlack commonMargin' : 'paddingT1 headingLarge'" class="marginB3">
                  {{ flashMessageEndEvent }}
                </h2>
                <div :class="$store.isSP ? 'commonMargin' : 'marginR3'" class="flash-message-preview">
                  <div class="imgSmallSize">
                    <common-image :image-object="event.eyecatch_image" :alt="event.eyecatch_image.alt" background-color="unset" itemprop="image" />
                  </div>
                  <p class="paddingL3 event-title">{{ displayTitleWithStatus }}</p>
                </div>
              </div>
            </template>
            <!-- Recommend Events For Past Event-->
            <div
              v-if="isPastEvent && (recommendEventsByArea.length > 1 || recommendEventsByOrganizer.length > 1)"
              :class="{ paddingT4: $store.isSP }"
              class="recommendEventsForPastEvent"
            >
              <template v-if="recommendEventsByArea.length > 1">
                <h2 class="recommendForPastEventHeading">{{ event.area_name }}でおすすめの{{ eventTypeName }}</h2>
                <slider-event-list :events="recommendEventsByArea" :from="'recommend-for-past-event'" class="scrollableBox-innerCustom" />
              </template>
              <template v-if="recommendEventsByOrganizer.length > 1">
                <h2 class="recommendForPastEventHeading">この主催者の{{ eventTypeName }}</h2>
                <slider-event-list :events="recommendEventsByOrganizer" :from="'recommend-for-past-event'" class="scrollableBox-innerCustom" />
              </template>
            </div>
            <!-- Similar Events For Past Event-->
            <SimilarEvent
              v-if="displayEventStatusFlashMessage"
              class="scrollableBox-innerCustom"
              :bookmarked-user-count="bookmarkedUserCount"
              use-opix="opixAPIRecommendEvents1New"
              @change-recommend-version-new="changeRecommendVersionNew"
              @plus-bookmark-count="applyChangeBookmarkCount(1)"
              @minus-bookmark-count="applyChangeBookmarkCount(-1)"
            />
            <template v-if="flashMessages.length > 0">
              <flash-message
                v-for="(flashMessage, idx) in flashMessages"
                :key="idx"
                :message="flashMessage.message"
                :type="flashMessage.type"
                class="marginB3"
              />
            </template>
            <div v-if="ticketInfo && ticketInfo.goto_campaign_event" class="gotoEventBanner">
              <p>Go Toイベント対象</p>
            </div>
            <EventEyecatches :event="event" :banner-stamp="!displayEventStatusFlashMessage ? bannerStamp : null" />
            <div class="detailHead-wrapper">
              <div class="detailHead">
                <div class="detailHead-location">
                  <div class="locationInfo">
                    <!--AREA LINK-->
                    <div v-if="isOnlineEvent" class="eventArea">
                      <span itemprop="address" class="eventArea-name">{{ eventOnlineAreaName }}</span>
                    </div>

                    <div v-else-if="event.online_event_type === 'online_service_linktext'" class="eventArea">オンライン</div>
                    <div v-else class="eventArea">{{ event.area_name }}</div>
                    <!--DETAIL TIME-->
                    <div class="locationInfo-dateTime">
                      <template v-if="onDuringDayEvent">
                        <time :datetime="startAt.isoString">
                          <span class="locationInfo-dateTime-date">{{ startAt.shortDateStandardWithWeekDayAndFormatHoliday }}</span>
                          <span v-if="!isBarGourmetEvent" class="locationInfo-dateTime-time">{{ startAt.timeShort }}〜{{ endAt.timeShort }}</span>
                        </time>
                      </template>
                      <template v-else>
                        <span class="locationInfo-dateTime-date">{{ startAt.shortDateStandardWithWeekDayAndFormatHoliday }}</span>
                        <span v-if="!isBarGourmetEvent" class="locationInfo-dateTime-time">{{ startAt.timeShort }}</span>
                        <span>〜</span>
                        <span class="locationInfo-dateTime-date">{{ endAt.shortDateStandardWithWeekDayAndFormatHoliday }}</span>
                        <span v-if="!isBarGourmetEvent" class="locationInfo-dateTime-time">{{ endAt.timeShort }}</span>
                      </template>
                    </div>
                  </div>
                  <!--BOOKMARK BUTTON-->
                  <div class="bookmarkButton">
                    <fav-button
                      v-if="filteredTicketInfo && loadedLatestTicketInfo"
                      :hide-count="false"
                      :event="event"
                      :bookmarked-user-count="bookmarkedUserCount"
                      @add-bookmark="applyChangeBookmarkCount(1)"
                      @remove-bookmark="applyChangeBookmarkCount(-1)"
                    />
                  </div>
                </div>
                <div class="detailHead-status-row">
                  <span v-if="event.fixed === 'fixed' || event.fixed === true" class="detailHead-fixed">開催確定</span>
                  <span v-if="endOfSaleAttention" class="end-of-sale-attention"> {{ endOfSaleAttention }}！ </span>
                </div>
                <div class="detailHead-title">
                  <h1 class="title">{{ displayTitleWithStatus }}</h1>
                </div>
              </div>
              <span v-if="groupDiscounts" class="detailHead-group-discount">グループ割引あり</span>
              <template v-if="!isAdvertisement">
                <ticket-info
                  v-if="filteredTicketInfo"
                  :event="event"
                  :ticket-info="filteredTicketInfo"
                  :disable-purchase-button="disablePurchaseButton"
                  :hide-purchase-button="hidePurchaseButton"
                  :lottery-deadline-at="lotteryDeadlineAt"
                  :loaded-latest-ticket-info="loadedLatestTicketInfo"
                  :lottery-result-time-at="lotteryResultTimeAt"
                  :has-ticket-set-sale="hasTicketSetSale"
                  :has-qualification-list-items="hasQualificationListItems"
                  @plus-bookmark-count="applyChangeBookmarkCount(1)"
                  @ticket-row-click="onTicketRowClick"
                  @purchase-event="onPurchaseButton"
                  @requirement-link-clicked="handleChangeEventTab('requirement')"
                />
              </template>
            </div>
            <EventOptions :event="event" />
            <DetailLineBanner />
            <template v-if="isOnlineServiceLinktextEvent">
              <h2 class="headingLarge">参加方法</h2>
              <div class="contentBlock commonCard">参加方法の詳細は、購入手続き完了後に上部メニュー「チケット」よりご確認いただけます。</div>
            </template>
            <a
              v-if="isBarGourmetEvent && event.external_site_url && event.external_site_text"
              :href="event.external_site_url"
              class="commonButton gray externalLinkButton"
              target="_blank"
            >
              <span class="externalLinkButton-text">{{ event.external_site_text }}</span>
              <icon class="externalLinkButton-icon" fas="fa-chevron-right" />
            </a>
            <related-feature-eyecatch v-if="customEyecatch" :event="event" />
            <div class="tabListWrapper">
              <nav class="tabList">
                <button
                  :class="{ active: currentNavigationTab === 'overview' }"
                  class="tabList-item commonButton btn-select-42"
                  @click="handleChangeEventTab('overview')"
                >
                  イベント<wbr />内容
                </button>
                <button
                  v-if="!isOnlineEvent"
                  :class="{ active: currentNavigationTab === 'eventFlow' }"
                  class="tabList-item commonButton btn-select-42"
                  @click="handleChangeEventTab('eventFlow')"
                >
                  当日の流れ
                </button>
                <button
                  v-if="!isOnlineEvent"
                  :class="{ active: currentNavigationTab === 'receptionPlace' }"
                  class="tabList-item commonButton btn-select-42"
                  @click="handleChangeEventTab('receptionPlace')"
                >
                  受付場所
                </button>
                <button
                  :class="{ active: currentNavigationTab === 'detailInfo' }"
                  class="tabList-item commonButton btn-select-42"
                  @click="handleChangeEventTab('detailInfo')"
                >
                  詳細情報
                </button>
              </nav>
            </div>
            <!-- EVENT DETAIL -->
            <old-event-detail
              v-if="event.detail.content"
              :content="event.detail.content"
              :external-url="externalUrl"
              :external-site-text="event.external_site_text"
              :can-show-external-link="!isBarGourmetEvent && !isCancelledEvent"
              :start-at="event.start_at"
            />
            <event-detail
              v-else-if="!(isBarGourmetEvent && $store.isSP)"
              ref="eventDetail"
              :event="event"
              :can-show-address="canShowAddress"
              :is-female-page="isFemalePage"
              @handle-element-in-view="handleElementInView"
              @handle-element-not-in-view="handleElementNotInView"
            />
            <div v-if="!isScrapedOnlineEvent" id="detailInfo" class="tab-target-inner">
              <intersection-observer @element-in-view="handleElementInView('detailInfo')" @element-not-in-view="handleElementNotInView('detailInfo')">
                <h2 class="opixDetailInfos headingLarge event-detail-heading">詳細情報</h2>
              </intersection-observer>
              <div class="detailTable contentBlock">
                <table class="commonTable wide">
                  <tbody>
                    <tr>
                      <td>開催日時</td>
                      <td>
                        <div v-html="$sanitizedXssHtml(organizeDateTime)" />
                        <span>{{ organizeTime }}</span>
                      </td>
                    </tr>
                    <template v-if="isBarGourmetEvent">
                      <tr>
                        <td>受付時間</td>
                        <td>
                          {{ firstFlowTime }}<span class="additionText">{{ receptionFlowDescription }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>受付場所</td>
                        <td>
                          <template v-if="event.place"> {{ event.place }}<br /> </template>
                          {{ event.address_full }}
                        </td>
                      </tr>
                    </template>
                    <tr v-if="event.place_phone_number && isBetweenStartDateAndEndDate">
                      <td>店舗連絡先</td>
                      <td>
                        <div>{{ event.place_phone_number }}</div>
                        ※場所が分からない場合のみ、上記の連絡先にご連絡をお願いいたします。
                      </td>
                    </tr>
                    <tr v-if="advertisementPrice">
                      <td>参加費</td>
                      <td>{{ advertisementPrice }}</td>
                    </tr>
                    <tr v-if="isForSale && !isOnlineEvent">
                      <td>予約締切</td>
                      <td>{{ saleEndAt }}</td>
                    </tr>
                    <template v-if="!isBarGourmetEvent">
                      <template v-if="!isOnlineEvent">
                        <tr>
                          <td>店舗数</td>
                          <td>
                            {{ event.num_of_places }}店舗
                            <span v-if="event.display_num_of_places_notice" class="noticeText">※店舗数は変更になる場合があります</span>
                          </td>
                        </tr>
                        <tr v-if="event.seating_style || event.seating_style_other">
                          <td>形式</td>
                          <td>
                            {{
                              event.seating_style !== 'other_format'
                                ? $useI18(`event.attributes.seating_style.${event.seating_style}`)
                                : event.seating_style_other
                            }}
                          </td>
                        </tr>
                        <tr v-if="event.food_provider || event.food_provider_other">
                          <td>フード</td>
                          <td>
                            {{
                              event.food_provider !== 'other'
                                ? $useI18(`event.attributes.food_provider.${event.food_provider}`)
                                : event.food_provider_other
                            }}
                          </td>
                        </tr>
                        <tr v-if="canDisplayDrinkProviderDetail">
                          <td>ドリンク</td>
                          <td>
                            <ul>
                              <li v-for="(drinkDetail, index) in event.drink_provider_detail" :key="index">{{ drinkDetail }}</li>
                            </ul>
                          </td>
                        </tr>
                        <tr v-if="canDisplayEventOptionalStyles">
                          <td>スタイル</td>
                          <td>
                            <ul>
                              <li v-for="(eventStyle, index) in event.event_optional_styles" :key="index">
                                {{ $useI18(`event.attributes.event_optional_style.${eventStyle.event_style}`) }}
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </template>
                      <tr
                        v-if="
                          event.is_show_event_min_num_of_people && ((event.min_num_of_female && event.min_num_of_male) || event.min_num_of_people)
                        "
                      >
                        <td>最少催行人数</td>
                        <td v-if="event.min_num_of_female && event.min_num_of_male">
                          <span class="male-label">男性</span> {{ event.min_num_of_male }}名　<span class="female-label">女性</span>
                          {{ event.min_num_of_female }}名
                        </td>
                        <td v-else>{{ event.min_num_of_people }}名</td>
                      </tr>
                      <tr v-if="event.is_show_num_of_people_range && event.num_of_people_range && event.num_of_people_range != 'no_show'">
                        <td>人数規模</td>
                        <td>
                          <div>{{ $useI18(`event.attributes.num_of_people_range.${event.num_of_people_range}`) }}</div>
                          <span class="inquiry">※キャンセル等により人数が若干変動する場合がございます。</span>
                        </td>
                      </tr>
                      <tr v-if="event.cancel_if_bad_weather">
                        <td>
                          {{ $useI18('event.messages.bad_weather_warning_title') }}
                        </td>
                        <td v-html="$sanitizedXssHtml(event.bad_weather_cancellation_warning)" />
                      </tr>
                      <tr
                        v-if="
                          event.display_reception_url &&
                          (event.reception_url || event.type === 'petit-con' || event.type === 'party') &&
                          isCancelledEvent
                        "
                      >
                        <td>受付場所</td>
                        <td v-if="event.petit_or_party">下記リンク先にて、受付店舗を事前にご確認下さい。</td>
                        <td v-else>下記リンク先にて、最初の受付店舗を事前にご確認下さい。</td>
                      </tr>
                      <tr v-else-if="event.representative_place_name && isCancelledEvent">
                        <td>代表店舗</td>
                        <td>{{ event.representative_place_name }}</td>
                        <br />
                        <template v-if="event.representative_place_address">{{ representative_place_address }}</template>
                        ※受付店舗が不明な場合上記の店舗までお越しください。スタッフが案内いたします。
                      </tr>
                    </template>
                    <tr v-if="event.alt_organizer_name">
                      <td>{{ $useI18('event.attributes.alt_organizer_name') }}</td>
                      <td class="preWrap" v-html="$sanitizedXssHtml(event.alt_organizer_name)" />
                    </tr>
                    <tr v-if="event.eve_online">
                      <td>前夜祭について</td>
                      <td><a :href="eveOnlineSupportLink">こちら</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <article v-if="!isScrapedOnlineEvent" id="requirement" class="participation-section tab-target-inner">
              <h2 id="organizer-heading" class="opixDetailInfos headingLarge event-detail-heading">参加条件</h2>
              <article class="participating-qualifications">
                <dl v-if="event.has_female_ticket || event.has_male_ticket" class="age-range-qualification">
                  <div v-if="event.has_male_ticket" class="age-row">
                    <dt class="qualification__gender-label qualification__male-label">
                      <Icon icomoon="male" class="blueSky" :size="2" /><span class="align-bottom-text">男性</span>
                    </dt>
                    <dd class="age-text">
                      <span class="align-bottom-text">{{ maleAgeRange }}</span>
                    </dd>
                  </div>
                  <div v-if="event.has_female_ticket" class="age-row">
                    <dt class="qualification__gender-label qualification__female-label">
                      <Icon icomoon="female" class="pinkDark" :size="2" /><span class="align-bottom-text">女性</span>
                    </dt>
                    <dd class="age-text">
                      <span class="align-bottom-text">{{ femaleAgeRange }}</span>
                    </dd>
                  </div>
                </dl>
                <dl class="qualification-list">
                  <div class="qualification-list-item">
                    <dt>{{ event.default_requirement_title }}</dt>
                    <dd v-if="event.id_verification === 'yes'" v-html="$sanitizedXssHtml(event.default_requirement_description)"></dd>
                    <dd v-if="(event.type === 'other' && event.id_verification === 'yes') || event?.married_ok">
                      ※ {{ event.default_requirement_title_other }}
                    </dd>
                  </div>

                  <div v-if="event.address_requirement_description" class="qualification-list-item">
                    <dt v-html="$sanitizedXssHtml(event.address_requirement_description)"></dt>
                  </div>

                  <div v-for="(req, idx) in requirementText" :key="`requirement-${idx}`" class="qualification-list-item">
                    <dt class="qualification-title">{{ req.title }}</dt>
                    <dd v-if="req.description">
                      <p
                        v-for="(text, i) in req.description"
                        :key="i"
                        v-html="$sanitizedXssHtml(`${i == 0 ? '※ ' : ''}${isOnlineEvent ? linkify(text) : text}`)"
                      ></p>
                    </dd>
                  </div>

                  <div v-if="event.target_audience_description && event.is_external_event" class="qualification-list-item">
                    <dt>その他条件</dt>
                    <dd v-html="$sanitizedXssHtml(cleanedTargetAudienceDescription)"></dd>
                  </div>

                  <div v-if="isOtherKonkatsuEvent" class="qualification-list-item">
                    <dt>恋活または婚活目的で参加される方</dt>
                    <dd>恋人探し・結婚相手探し両方の目的で参加される方がいることにご理解の上、参加いただけること</dd>
                  </div>
                </dl>

                <div class="event-requirement-alert">
                  <span class="event-requirement-alert-icon event-requirement-alert-icon-circle">
                    <Icon fas="fa-exclamation-circle" :size="1.7" color="orange" />
                  </span>
                  <span class="event-requirement-alert-text" v-html="$sanitizedXssHtml(eventDefaultRequirementDescription2)"></span>
                </div>
              </article>
            </article>
            <template v-if="event.organizer_name">
              <h2 id="organizer-heading" class="opixDetailInfos headingLarge event-detail-heading">主催者情報</h2>
              <article class="organizer" aria-labelledby="organizer-heading">
                <section aria-label="Organizer information" class="organizer-info">
                  <template v-if="detailOrganizerMessageSection && detailOrganizerMessageSection.sections[0].caption && !event.syumiplus_tag">
                    <template v-for="(origanizerMessage, sIdx) in detailOrganizerMessageSection.sections" :key="sIdx">
                      <common-lazy-load-image
                        v-if="origanizerMessage.image"
                        class="organizer-image"
                        :image-object="origanizerMessage.image"
                        :alt="origanizerMessage.image.alt"
                      />
                    </template>
                  </template>
                  <dl class="organizer-details">
                    <dt>主催者名</dt>
                    <dd>
                      <custom-nuxt-link v-if="event.organizer_visible_review" :to="organizerReviewLink" class="contact">
                        {{ event.organizer_name }}
                      </custom-nuxt-link>
                      <p v-else>
                        {{ event.organizer_name }}
                      </p>
                    </dd>
                    <template v-if="event.opening_times">
                      <dt>営業時間</dt>
                      <dd>{{ event.opening_times }}</dd>
                    </template>
                    <template v-if="eventOpenNow ? event.contact : event.staff_tel">
                      <dt>連絡先</dt>
                      <dd>{{ eventOpenNow ? event.contact : event.staff_tel }}</dd>
                    </template>
                  </dl>
                </section>
                <section aria-label="Contact" class="organizer-contact">
                  <div class="contact-buttons">
                    <button
                      v-if="eventOpenNow ? event.contact : event.staff_tel"
                      class="commonButton btn-secondary-40"
                      @click="makeCall(eventOpenNow ? event.contact : event.staff_tel)"
                    >
                      <icon fas="fa-phone-alt" class="button-icon" />
                      電話
                    </button>
                    <button v-if="!isCancelledEvent" class="commonButton btn-secondary-40" @click="handleOpenContactInfoModal">
                      <icon fas="fa-envelope" class="button-icon" />
                      メッセージ
                    </button>
                  </div>

                  <div class="inquiry">
                    <span v-if="contactTextItem">※{{ contactTextItem }}<br /></span>
                    <span v-if="openTimeItem">
                      ※営業時間外のお問い合わせにつきましては、翌営業日以降の対応とさせていただきます。
                      <br />
                    </span>
                    <span v-if="event.display_supplement_inquiry">※集客状況などの変動する内容は、お問い合わせいただいてもお伝えできかねます。 </span>
                  </div>
                </section>
                <section
                  v-if="event.organizer_visible_review && displayUserReviews.length > 0"
                  id="organizerReview"
                  aria-label="Comments"
                  class="user-reviews"
                >
                  <h3 class="user-reviews-title">主催者の口コミ</h3>
                  <EventOrganizerReviewItem v-for="(userReview, index) in displayUserReviews" :key="index" :user-review="userReview" />
                  <custom-nuxt-link :to="organizerReviewLink" class="commonButton btn-secondary-40"> 主催者の口コミをもっと見る </custom-nuxt-link>
                </section>
                <section
                  v-if="detailOrganizerMessageSection && detailOrganizerMessageSection.sections[0].caption && !event.syumiplus_tag"
                  class="organizer-message"
                >
                  <h3>主催者から<wbr />一言</h3>
                  <div v-for="(organizerMessage, sIdx) in detailOrganizerMessageSection.sections" :key="sIdx">
                    <p v-html="$sanitizedXssHtml(organizerMessage.caption)"></p>
                  </div>
                </section>
                <section v-if="organizerEvents && organizerEvents.length > 0" class="organizerEvents" aria-labelledby="organizer-events-header">
                  <h3 id="organizer-events-header" class="organizerEvents-header">{{ event.organizer_name }}のイベント</h3>
                  <recommend-event-list-sp
                    :events="organizerEvents"
                    :show-scroll-element="false"
                    class="marginB5"
                    @plus-bookmark-count="applyChangeBookmarkCount(1)"
                    @minus-bookmark-count="applyChangeBookmarkCount(-1)"
                  />
                  <div class="organizerEvents-moreButtonWrapper">
                    <custom-nuxt-link v-if="organizerEventsLink" :to="organizerEventsLink" class="commonButton btn-secondary-50">
                      この主催者のイベントをもっと見る
                    </custom-nuxt-link>
                  </div>
                </section>
              </article>
            </template>
            <template v-if="canDisplayNoticeForCovid19">
              <div class="opixRequestCustomer headingLarge">お客様へのお願い</div>
              <div class="contentBlock commonCard">
                <ul class="simpleList noticeForCovid19">
                  <li v-for="(content, i) in covid19NoticeContents" :key="i" class="noticeForCovid19-item">
                    <div class="noticeForCovid19-item-image">
                      <img v-for="(url, j) in content.imageUrls" :key="j" :src="url" />
                    </div>
                    <div class="noticeForCovid19-item-content textJustify">
                      {{ content.text }}
                      <div v-for="(note, k) in content.notes" :key="k" class="noticeForCovid19-item-content-note">
                        {{ note }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
            <ul v-if="$store.$state.native_app" class="socialLinks pcHidden">
              <li class="socialLinks-item commonButton line">
                <a :href="`http://line.naver.jp/R/msg/text/?${displayTitle}%0a${ROOT_URL}${$route.path}`"
                  ><icon :size="2" icomoon="logo-line" /><span class="socialLinks-item-text">LINEで友達を誘う</span></a
                >
              </li>
              <li class="socialLinks-item commonButton mail">
                <a :href="`mailto:?subject=${displayTitle}&body=${displayTitle}%0a${ROOT_URL}${$route.path}`"
                  ><icon :size="2" fas="fa-envelope" /><span class="socialLinks-item-text">メールで友達を誘う</span></a
                >
              </li>
            </ul>
            <!-- 女性用よくある質問セクション -->
            <FemaleQASection :is-female-page="isFemalePage" :detail-female-qa-section="detailFemaleQASection" />
            <template v-if="!isScrapedOnlineEvent">
              <section id="opixCautions" class="tab-target-inner">
                <intersection-observer @element-in-view="handleElementInView('opixCautions')">
                  <h2 class="headingLarge event-detail-heading">注意事項</h2>
                </intersection-observer>
                <ul ref="cautionList" class="simpleList contentBlock">
                  <li
                    v-for="(text, i) in cautionText"
                    :key="i"
                    :class="{ hasContent: text !== '<br>' }"
                    class="simpleList-item textJustify"
                    v-html="$sanitizedXssHtml(text)"
                  ></li>
                  <li v-if="event.eve_online" class="simpleList-item hasContent textJustify">
                    前夜祭はmachicon
                    JAPANが無料で提供しているサービスです。環境やシステム障害等によってご参加いただけない場合でもイベントチケット代金の返金対象になりません。（前夜祭に関するお問い合わせは
                    <a :href="eveOnlineSupportLink">こちら</a>）
                  </li>
                </ul>
              </section>
              <section class="opixProhibitions marginB4">
                <h2 class="headingLarge event-detail-heading">禁止事項</h2>
                <div class="contentBlock prohibition-section">
                  <p class="ruleTitle textJustify">
                    当社は、他の参加者から迷惑行為の通報を受け事実を確認できた場合、法的手段を講じることがあります。規約違反の参加者を発見された場合、連絡をお願いします。
                  </p>
                  <p class="rule-contact">
                    連絡先：
                    <a :href="`https://support.machicon.jp/hc/ja/requests/new?ticket_form_id=15677962369561&event=${event.title}`" target="_blank"
                      >お問い合わせ</a
                    >
                  </p>
                  <ul ref="prohibitionList" class="simpleList prohibition-list">
                    <li v-if="isMinorParticipantsContainingOfflineEvent" class="simpleList-item hasContent textJustify">
                      満20歳未満の飲酒・喫煙及び、それらを助長する行為
                    </li>
                    <li
                      v-for="(text, i) in prohibitionText"
                      :key="i"
                      :class="{ hasContent: text !== '<br>' }"
                      class="simpleList-item textJustify"
                      v-html="$sanitizedXssHtml(text)"
                    ></li>
                  </ul>
                </div>
              </section>
            </template>
          </div>
          <div v-if="$store.isPC" class="container-side">
            <side-content-pc :options="{ eventInterest: event.have_interest, eventType: event.type }" />
          </div>
        </div>
      </div>
      <div class="grayBg">
        <div class="container marginY0">
          <div class="contentBoxSp eventCustomBox">
            <AlternativeDateEvent
              :bookmarked-user-count="bookmarkedUserCount"
              @change-recommend-version="changeAlternativeDateRecommendVersion"
              @plus-bookmark-count="applyChangeBookmarkCount(1)"
              @minus-bookmark-count="applyChangeBookmarkCount(-1)"
            />
            <div v-if="hasGroupID" class="group-event">
              <custom-nuxt-link :to="`/similar_event_group/${event.similar_group_id}`" class="group-event-button commonButton btn-secondary-50">
                すべての開催予定を見る
              </custom-nuxt-link>
            </div>
            <SimilarEvent
              :bookmarked-user-count="bookmarkedUserCount"
              use-opix="opixAPIRecommendEvents2New"
              @change-recommend-version-new="changeRecommendVersionNew"
              @plus-bookmark-count="applyChangeBookmarkCount(1)"
              @minus-bookmark-count="applyChangeBookmarkCount(-1)"
            />
            <recommend-events-personalized :prefecture-slug="event.prefecture_slug" :current-event-id="event.id" />
            <recent-checked-events
              :display-limit="10"
              :current-event-id="event.id"
              :is-event-detail="true"
              :custom-sp-design="true"
              class="opixRecentCheckedEvents commonSection"
              @plus-bookmark-count="applyChangeBookmarkCount(1)"
              @minus-bookmark-count="applyChangeBookmarkCount(-1)"
            />
            <div v-if="!$store.isLoggedIn && searchByCloseAreaLinks.length" class="commonSection">
              <h2 class="opixOtherKonkatsuEvents commonSectionHeading">近隣エリアの{{ eventTypeName }}を探す</h2>
              <related-area-link-list :links="searchByCloseAreaLinks" />
            </div>
            <div class="commonSection">
              <h2 class="opixOtherMachiconEvents commonSectionHeading">他の街コン・{{ eventTypeName }}を探す</h2>
              <related-area-link-list :links="searchByAreaLinks" />
            </div>
            <template v-if="!isPastEvent">
              <div v-if="specialtyPrefectureEventList" class="commonSection customizeEventSize">
                <h2 class="opixSpecialtyPrefectureEventList commonSectionHeading">
                  {{ specialtyPrefectureEventList.title }}
                </h2>
                <slider-event-list
                  v-if="specialtyPrefectureEvents.length > 0"
                  :events="specialtyPrefectureEvents"
                  :from="'specialty-prefecture-event-list'"
                  class="imageHeightAuto"
                  @click-from-specialty-prefecture-event-list="sendOpixClickDatas"
                />
              </div>
              <div v-if="specialtyKonkatsuEventList" class="commonSection customizeEventSize">
                <h2 class="opixSpecialtyKonkatsuEventList commonSectionHeading">
                  {{ specialtyKonkatsuEventList.title }}
                </h2>
                <slider-event-list
                  v-if="specialtyKonkatsuEvents.length > 0"
                  :events="specialtyKonkatsuEvents"
                  :from="'specialty-konkatsu-event-list'"
                  class="imageHeightAuto"
                  @click-from-specialty-konkatsu-event-list="sendOpixClickDatas"
                />
              </div>
            </template>
            <side-content-sp class="opixSideContentSp commonMargin" />
            <!-- Public relations -->
            <public-relations :custom-for-event-detail="true" :custom-sp-design="true" class="opixPublicRelations commonSection" />
            <breadcrumbs :options="firstRowBreadCrumbOptions" page="event" display-mode="footer" class="opixFooterBreadcrumbs breadcrumb" />
            <breadcrumbs
              :options="secondRowBreadCrumbOptions"
              page="event"
              display-mode="footer"
              class="opixFooterBreadcrumbs breadcrumb"
              enable-structured-jsonld
            />
            <breadcrumbs
              v-if="event.feature_tags.length > 0"
              :options="thirdRowBreadCrumbOptions"
              page="event"
              display-mode="footer"
              class="opixFooterBreadcrumbs breadcrumb"
            />
          </div>
          <transition v-if="contactInfoModalOpenned" name="fadeScale">
            <contact-info-modal
              :event="event"
              :modal="modalContact"
              :has-purchased-ticket="hasPurchasedTicket"
              @update-content="updateModalContact"
              @close-modal="handleCloseContactInfoModal"
            />
          </transition>
        </div>
        <transition name="fadeQuiq">
          <div
            :class="[
              { breakLinePadding: hasLargeText, disappear: !($store.isSP && displayNoticeMessage) || displayNoticeMessageMode === 'complete' },
              noticeABTestFooterClass.noticeFooter
            ]"
            class="noticeFooter paddingR5"
          >
            <div
              :class="noticeABTestFooterClass.closeButton"
              role="button"
              aria-label="トーストを閉じる"
              @click="displayNoticeMessageMode = 'complete'"
            >
              ×
            </div>
            <transition name="fadeQuiq">
              <div
                :class="[
                  { disappear: !($store.isSP && displayNoticeMessage) || displayNoticeMessageMode !== 'saleEnd' },
                  noticeABTestFooterClass.noticeMessage
                ]"
              >
                <icon :size="1.5" class="paddingR1" far="fa-clock" /> 販売終了まで残り{{ saleLimitText }}！
              </div>
            </transition>
            <transition :name="displaySaleEnd ? 'fadeSlideRight' : 'fadeOut'">
              <div
                ref="accessCount"
                :class="[
                  { disappear: !($store.isSP && displayNoticeMessage) || displayNoticeMessageMode !== 'accessCount' },
                  noticeABTestFooterClass.noticeMessage
                ]"
              >
                <div :class="{ smallScreenIcon: hasLargeText }" class="noticeFooter-icon">
                  <icon :size="1.5" class="paddingR1" fas="fa-user-friends" />
                </div>
                本日、<b> {{ numOfAccessedUsersInfo.access_count }}</b
                >人 {{ countedGenderText }} がこのイベントを見ています
              </div>
            </transition>
          </div>
        </transition>
        <transition v-if="filteredTicketInfo && filteredTicketInfo.tickets.length > 0 && !$store.event_search_modal" name="fade">
          <float-footer
            v-show="showFloatFooter"
            :event="event"
            :button-text="filteredTicketInfo ? filteredTicketInfo.fixed_ticket_button_message : ''"
            :disable-button="disablePurchaseButton"
            :hide-button-icon="(filteredTicketInfo && filteredTicketInfo.can_buy_with_konkatsu_freepass) || false"
            :loaded-latest-ticket-info="loadedLatestTicketInfo"
            :has-ticket-set-sale="hasTicketSetSale"
            @purchase-event="onPurchaseButton"
            @plus-bookmark-count="applyChangeBookmarkCount(1)"
            @minus-bookmark-count="applyChangeBookmarkCount(-1)"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { useABTest } from '@/composables/abtest/useABTest'
import { EVENT_DETAIL_TOAST_AB_TEST_CONFIG } from '@/composables/abtest/abTestConfig'
import { mapSettings } from '@/utils/settings'
import { numberToCurrency, timeConverter } from '@/utils/converter'
import {
  ADULTHOOD_AGE,
  COVID_19_NOTICE_IN_AUGUST,
  COVID_19_NOTICE_IN_MARCH_2023,
  COVID_19_NOTICE_IN_MAY,
  MODAL_CONTENT,
  MODAL_CONTACT
} from '@/utils/constants/commons'
import moment from 'mj-moment'
import GTM from '@/utils/tracking/gtm'
import AdvertisementData from '@/utils/AdvertisementData'
import { isFemalePageTarget } from '@/utils/femalePageConfig'
import PageDetector from '@/utils/PageDetector'
import bus from '@/utils/bus'
import EventDetailMixin from '@/utils/mixins/EventDetailMixin'
import OnlineEventMixin from '@/utils/mixins/OnlineEventMixin'
import TrackingUserMixin from '@/utils/mixins/TrackingUserMixin'
import EventDetailJsonld from '@/utils/mixins/EventDetailJsonld'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { SEARCH_AND_EVENT_DETAIL_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import { ISSUE_434_DETAIL_VIEW } from '@/utils/constants/gaCustomEventSet'
import UserModel from '@/models/users'
import { parseCautionText, parseProhibitionText } from '@/utils/TextUtils'
import useEventTitleABTest from '@/composables/useEventTitleABTest'
import { isEventInABTest } from '@/utils/abtest/eventTitleMapping'
const SideContentPc = defineAsyncComponent(() => import('@/components/side/SideContentPc.vue'))
const SideContentSp = defineAsyncComponent(() => import('@/components/side/SideContentSp.vue'))
const EventDetail = defineAsyncComponent(() => import('@/components/event/EventDetail.vue'))
const OldEventDetail = defineAsyncComponent(() => import('@/components/event/OldEventDetail.vue'))
const FloatFooter = defineAsyncComponent(() => import('@/components/event/FloatFooter.vue'))
const RecommendationServices = defineAsyncComponent(() => import('@/components/banner/RecommendationServices.vue'))
const Features = defineAsyncComponent(() => import('@/components/banner/Features.vue'))
const TieUp = defineAsyncComponent(() => import('@/components/banner/TieUp.vue'))
const Breadcrumbs = defineAsyncComponent(() => import('@/components/Breadcrumbs.vue'))
const EventArea = defineAsyncComponent(() => import('@/components/event/EventArea.vue'))
const CommonImage = defineAsyncComponent(() => import('@/components/CommonImage.vue'))
const CommonLazyLoadImage = defineAsyncComponent(() => import('@/components/CommonLazyLoadImage.vue'))
import { scrollToTop } from '@/utils/ScrollTo'
const AddLineFriend = defineAsyncComponent(() => import('@/components/AddLineFriend.vue'))
const CouplinkMobileApps = defineAsyncComponent(() => import('@/components/CouplinkMobileApps.vue'))
const RecentCheckedEvents = defineAsyncComponent(() => import('@/components/RecentCheckedEvents.vue'))
const FavButton = defineAsyncComponent(() => import('@/components/FavButton.vue'))
import CriteoGtmDatalayer from '@/utils/CriteoGtmDatalayer'
const PublicRelations = defineAsyncComponent(() => import('@/components/banner/PublicRelations.vue'))
const RelatedFeatureEyecatch = defineAsyncComponent(() => import('@/components/event/RelatedFeatureEyecatch.vue'))
import linkifyHtml from 'linkifyjs/html'
import { OPIX_EVENTS_CHECK_POINTS_ON_EVENT_DETAIL_PAGE } from '@/utils/constants/opixTracking'
const RecommendEventsPersonalized = defineAsyncComponent(() => import('@/components/RecommendEventsPersonalized.vue'))
const ScrollEventList = defineAsyncComponent(() => import('@/components/event/ScrollEventList.vue'))
import { GA4_VIEW_ITEM } from '@/utils/constants/ga4'
import SearchRoutes from '@/router/searchRoutes'
import { useMainStore } from '@/store'
import { reactive } from 'vue'
import { callWithNuxt } from 'nuxt/app'
import EventModel from '@/models/events'

const KonkatsuFreepass = defineAsyncComponent(() => import('@/components/event/KonkatsuFreepass.vue'))
const Menpass = defineAsyncComponent(() => import('@/components/event/Menpass.vue'))
const SliderEventList = defineAsyncComponent(() => import('@/components/event/SliderEventList.vue'))
const OnlineFitnessPass = defineAsyncComponent(() => import('@/components/event/OnlineFitnessPass.vue'))
const OnlineCafetalkYogaPass = defineAsyncComponent(() => import('@/components/event/OnlineCafetalkYogaPass.vue'))
const TicketInfo = defineAsyncComponent(() => import('@/components/event/TicketInfo.vue'))
const ContactInfoModal = defineAsyncComponent(() => import('@/components/modals/ContactInfoModal.vue'))
const FlashMessage = defineAsyncComponent(() => import('@/components/FlashMessage.vue'))
const CommonFlashMessage = defineAsyncComponent(() => import('@/components/CommonFlashMessage.vue'))
const NotificationMessage = defineAsyncComponent(() => import('@/components/NotificationMessage.vue'))
const SimilarEvent = defineAsyncComponent(() => import('@/components/recommend/SimilarEvent.vue'))
const AlternativeDateEvent = defineAsyncComponent(() => import('@/components/recommend/AlternativeDateEvent.vue'))
const RelatedAreaLinkList = defineAsyncComponent(() => import('@/components/search/RelatedAreaLinkList.vue'))
const RecommendEventListSp = defineAsyncComponent(() => import('@/components/event/RecommendEventListSp.vue'))
const FemaleQASection = defineAsyncComponent(() => import('@/components/event/FemaleQASection.vue'))
const EventOptions = defineAsyncComponent(() => import('@/components/event/EventOptions.vue'))
const DetailLineBanner = defineAsyncComponent(() => import('@/components/event/DetailLineBanner.vue'))

const NUM_OF_SPECIAL_EVENT_DISPLAY = 3
const MAX_RECOMMEND_EVENTS_FOR_PAST_EVENT = 10
const LOWER_BOUND_OF_DISPLAY_ACCESS_COUNT = 5
const DISPLAY_NOTICE_WINDOW_TIME = 5000 // ms
const DISPLAY_SALE_LIMIT_TIME_UPPER = 1728e5 // 2days * 24 hour * 60 min * 60 * 1000 ms
const DISPLAY_SALE_LIMIT_TIME_LOWER = 60 * 1000 // ms
const DISPLAY_SALE_ONE_HOUR_UPPER_LIMIT = 60 // min
const DISPLAY_SALE_ONE_DAY_UPPER_LIMIT = 1440 // 24 hours * 60 min
const ONLINE_EVENT_QUERY_VALUES = {
  vbar_night: 'vbar_night',
  vbar_day: 'vbar_daytime',
  online_konkatsu: 'konkatsu',
  five_minutes: '5min',
  and_girl: 'and_girl'
}
const START_SHOW_NOTICE_FOR_COVID_19_IN_MAY = '2020-05-18'
const START_SHOW_NOTICE_FOR_COVID_19_IN_AUGUST = '2020-08-01'
const START_SHOW_NOTICE_FOR_COVID_19_IN_2023_MARCH = '2023-03-13'
const CAN_SHOW_NOTICE_FOR_COVID_19 = '2023-05-08'
const OTOCON_ORGANIZER_NAME = 'OTOCON（おとコン）'
const LIST_TO_NAME = [
  'purchases',
  'events-code-tickets-ticket_id-purchase_options',
  'events-code-tickets-ticket_id-purchases-new',
  'events-code-tickets-ticket_id-guest_purchases-new',
  'events-code-tickets-ticket_id-amazon_purchases-new',
  'events-code-tickets-ticket_id-amazon_purchases-guest_new',
  'purchases-id-companions-new'
]
const NOTICE_VARIANTS = {
  a: {
    noticeFooter: 'noticeFooterA',
    noticeMessage: 'noticeFooterA-noticeMessageA',
    closeButton: 'noticeFooterA-closeButtonA'
  },
  b: {
    noticeFooter: 'noticeFooterB',
    noticeMessage: 'noticeFooterB-noticeMessageB',
    closeButton: 'noticeFooterB-closeButtonB'
  }
}
export default defineNuxtComponent({
  beforeRouteLeave(to, _from, next) {
    this.$store.SET_STATE({ key: 'is_to_search_page_from_event_page', value: SearchRoutes.ListSearchEventsRoutesSet.includes(to.name) })
    if (LIST_TO_NAME.includes(to.name)) {
      this.$store.SET_STATE({ key: 'event_detail_to_purchase', value: true })
    }
    next()
  },
  components: {
    KonkatsuFreepass,
    Menpass,
    OnlineFitnessPass,
    OnlineCafetalkYogaPass,
    SideContentPc,
    SideContentSp,
    EventDetail,
    OldEventDetail,
    TicketInfo,
    FloatFooter,
    RecommendationServices,
    Features,
    TieUp,
    CommonFlashMessage,
    FlashMessage,
    EventArea,
    Breadcrumbs,
    CommonImage,
    CommonLazyLoadImage,
    AddLineFriend,
    CouplinkMobileApps,
    RecentCheckedEvents,
    FavButton,
    SliderEventList,
    PublicRelations,
    RelatedFeatureEyecatch,
    RecommendEventsPersonalized,
    NotificationMessage,
    ContactInfoModal,
    ScrollEventList,
    SimilarEvent,
    AlternativeDateEvent,
    RelatedAreaLinkList,
    RecommendEventListSp,
    FemaleQASection,
    EventOptions,
    DetailLineBanner
  },
  mixins: [EventDetailMixin, OnlineEventMixin, TrackingUserMixin, EventDetailJsonld],
  async setup() {
    const route = useRoute()
    const store = useMainStore()
    const app = useNuxtApp()
    const params = route.params

    const apiUrl = route.name === 'event_previews' ? `preview/events/${params.code}/` : `events/${params.code}/`
    const requests = []
    const adParams = {
      featured: true,
      recommendations: true,
      tie_ups: true
    }
    definePageMeta({
      middleware: ['redirect-event'],
      validate(route) {
        return route.params.code ? true : false
      }
    })
    const advertisementData = new AdvertisementData(store, adParams)
    const criteoGtmDatalayer = new CriteoGtmDatalayer(store)
    const eventRequest = store.dispatch('apiGetV2', apiUrl).then(response => {
      const data = response.data
      if (data.redirect_path) {
        return callWithNuxt(app, () => navigateTo({ path: data.redirect_path, query: { fmcs: route.query.fmcs } }, { redirectCode: 301 }))
      }
      // 女性用のイベント詳細ページのバリデーションチェック
      const pageDetector = new PageDetector(route)
      if (pageDetector.isEventDetailFemalePage) {
        // 女性用のデータがない場合、または男性のユーザーの場合はイベント詳細ページにリダイレクト
        const detailFemaleRecommend = data.event.detail?.contents?.find(v => v.female_recommend && v.sections?.length > 0)
        if (isFemalePageTarget(data.event.organizer_id) && (!detailFemaleRecommend || store.isMaleUser)) {
          const query = { ...route.query }
          return callWithNuxt(app, () => navigateTo({ path: `/events/${data.event.code}`, query }, { redirectCode: 301 }))
        }
      }

      // to display footer konkatsu bottom links
      store.LAYOUT_DATA({ type: 'footer', data: { event_type: data.event.type } })
      callWithNuxt(app, () =>
        useHeadParams({
          $route: route,
          meta: data.meta,
          event: data.event
        })
      )
      return {
        meta: data.meta,
        event: data.event,
        specialtyPrefectureEventList: data.specialty_prefecture_events,
        specialtyKonkatsuEventList: data.specialty_konkatsu_events,
        searchByAreaLinks: data.search_by_area_links || [],
        searchByCloseAreaLinks: data.search_by_close_area_links || [],
        noindex: data.noindex,
        // for konkatsu freepass event
        konkatsuFreepass: data.konkatsu_freepass,
        hasActiveKonkatsuFreepass: data.has_active_konkatsu_freepass,
        hasPendingKonkatsuFreepassPurchases: data.has_pending_konkatsu_freepass_purchases,
        konkatsuFreepassTickets: data.konkatsu_freepass_tickets,
        // for mens pass event
        mensPass: data.mens_pass,
        hasActiveMensPass: data.has_active_mens_pass,
        hasPendingMensPass: data.has_pending_mens_pass,
        mensPassTicketId: data.mens_pass_ticket_id,
        ticketInfo: data.ticket_info || null,
        // for online fitness pass event
        onlineFitnessPass: data.online_fitness_pass,
        hasActiveOnlineFitnessPass: data.has_active_online_fitness_pass,
        videos: data.videos || [],
        room1Url: data.room_1_url,
        room2Url: data.room_2_url,
        supportRoomLink: data.support_room_link,
        videoSettingSupportLink: data.video_setting_support_link,
        communicationRoomLink: data.communication_room_link,
        // for online cafetalk yoga pass
        onlineCafetalkYogaPass: data.online_cafetalk_yoga_pass,
        hasActiveOnlineCafetalkYogaPass: data.has_active_online_cafetalk_yoga_pass,
        schedule: data.schedule,
        userReviews: data.event.organizer_user_reviews || [],
        femaleUserReviews: data.event.organizer_female_user_reviews || []
      }
    })

    // Initialize event title A/B test composable
    const { getTitle, trackDetailView } = useEventTitleABTest()

    requests.push(eventRequest)

    const isEventPreviewPage = route.name === 'event_previews'
    if (!isEventPreviewPage) {
      const bookmarkedCountRequest = store.dispatch('apiGetV2', `events/${route.params.code}/bookmarked_count`).then(response => {
        const data = response.data
        return {
          bookmarkedUserCount: data.bookmarked_user_count
        }
      })
      requests.push(bookmarkedCountRequest)
    } else {
      const emptyPromise = new Promise((resolve, _reject) => {
        resolve({ bookmarkedUserCount: 0 })
      })
      requests.push(emptyPromise)
    }

    const headerInformationsRequest = store.dispatch('apiGetV2', 'announcements/header_informations').then(response => {
      return {
        headerInformationsForEventDetail: response.data.header_informations.filter(item => item.show_header_on_event_detail === true)
      }
    })
    requests.push(headerInformationsRequest)

    const fetchOrganizerEvents = async code => {
      try {
        const response = await store.dispatch('apiGetV2', `events/${code}/organizer_events`)
        return { organizerEvents: response.data.organizer_events }
      } catch (_e) {
        return { organizerEvents: [] }
      }
    }

    if (!isEventPreviewPage) {
      requests.push(fetchOrganizerEvents(route.params.code))

      const eventContactId = store.dispatch('apiGetV2', `events/${route.params.code}/event_contact_info`).then(response => {
        return {
          contactText: response.data.contact_text,
          openingTimes: response.data.opening_times
        }
      })
      requests.push(eventContactId)
    } else {
      requests.push(Promise.resolve({ organizerEvents: [] }))

      const emptyPromiseContactText = new Promise((resolve, _reject) => {
        resolve({
          contactText: null,
          openingTimes: null
        })
      })
      requests.push(emptyPromiseContactText)
    }

    requests.push(advertisementData.fetchData())
    requests.push(criteoGtmDatalayer.fetchData())

    const { abGroup, sendOnEventDetailPageClick } = usePaymentFlowABTest()

    try {
      const [mainContents, bannerContents, gtmContents, bookmarkedCounts, headerInformations, organizerEventsData, eventContactId] =
        await Promise.all(requests)
      if (!mainContents) return
      // if (process.server && mainContents.event.status === 'terminated') res.statusCode = 404
      return reactive({
        ...mainContents,
        ...bannerContents,
        ...gtmContents,
        ...bookmarkedCounts,
        ...headerInformations,
        ...organizerEventsData,
        ...eventContactId,
        // Event title A/B test composable
        getTitle,
        trackDetailView,
        // Payment flow A/B test composable
        abGroup,
        sendOnEventDetailPageClick
      })
    } catch (e) {
      const errorCode = parseInt(e.response && e.response.status)
      await callWithNuxt(app, async () => await app.$error(errorCode))
    }
  },
  data: function () {
    return {
      isLotteryWating: false,
      ticketInfo: null,
      flashMessages: [],
      recommendEventsByArea: [],
      recommendEventsByOrganizer: [],
      displayNoticeMessageMode: null,
      numOfAccessedUsersInfo: {},
      baseCheckPoints: [...OPIX_EVENTS_CHECK_POINTS_ON_EVENT_DETAIL_PAGE],
      hasLargeTextAccessCount: false,
      bookmarkedUserCount: 0,
      modalContact: null,
      contactInfoModalOpenned: false,
      hasDetailInfoTabClicked: false,
      alternativeDateRecommendVersion: null,
      recommendVersionNew: null,
      toastABTestAPattern: false,
      toastABTestBPattern: false,
      isCautionOpen: false,
      isProhibitionOpen: false,
      elementsInView: {
        overview: false,
        eventFlow: false,
        receptionPlace: false,
        detailInfo: false
      },
      previousNavigationTab: 'overview'
    }
  },
  computed: {
    ...mapSettings(['ROOT_URL']),
    isFemalePage() {
      return this.pageDetector.isEventDetailFemalePage
    },
    displayTitle() {
      const abTestTitle = this.getTitle(this.event)
      return abTestTitle || this.event.title
    },
    displayTitleWithStatus() {
      const status = this.eventStatus
      const title = isEventInABTest(this.event.id) ? this.displayTitle : this.event.title

      return status + title
    },
    cleanedTargetAudienceDescription() {
      if (this.event && this.event.target_audience_description) {
        return this.event.target_audience_description.replace(/(<br\s*\/?>)+$/gi, '')
      }
      return ''
    },
    myBirthday() {
      return this.$store.my_profile ? this.$store.my_profile.birthday : null
    },
    currentNavigationTab() {
      for (const [tab, isInView] of Object.entries(this.elementsInView)) {
        if (isInView) return tab
      }

      return this.previousNavigationTab
    },
    canDisplayNoticeForCovid19() {
      return (
        !this.isOnlineEvent &&
        moment(this.event.start_at).isBetween(moment(START_SHOW_NOTICE_FOR_COVID_19_IN_MAY), moment(CAN_SHOW_NOTICE_FOR_COVID_19), 'day', '()')
      )
    },
    canDisplayDrinkProviderDetail() {
      return this.event.drink_provider_detail?.length > 0
    },
    canDisplayEventOptionalStyles() {
      return this.event.event_optional_styles?.length > 0
    },
    eventStatus() {
      return this.displayEventStatusFlashMessage ? '※販売終了※ ' : ''
    },
    flashMessageEndEvent() {
      if (this.isCancelledEvent) return this.$useI18('event.messages.cancelled')
      if (this.isPastEvent) return this.$useI18('event.messages.finished')
      return ''
    },
    organizerReviewLink() {
      return `/review/${this.event?.organizer_promoter_event_slug}`
    },
    covid19NoticeContents() {
      if (moment(this.event.start_at).isBefore(moment(START_SHOW_NOTICE_FOR_COVID_19_IN_AUGUST), 'day')) return COVID_19_NOTICE_IN_MAY
      if (moment(this.event.start_at).isBefore(moment(START_SHOW_NOTICE_FOR_COVID_19_IN_2023_MARCH), 'day')) return COVID_19_NOTICE_IN_AUGUST
      return COVID_19_NOTICE_IN_MARCH_2023
    },
    displayEventStatusFlashMessage() {
      return this.isCancelledEvent || this.isPastEvent
    },
    specialtyPrefectureEvents() {
      return this.$store.isSP
        ? this.specialtyPrefectureEventList.events
        : this.specialtyPrefectureEventList.events.slice(0, NUM_OF_SPECIAL_EVENT_DISPLAY)
    },
    specialtyKonkatsuEvents() {
      return this.$store.isSP ? this.specialtyKonkatsuEventList.events : this.specialtyKonkatsuEventList.events.slice(0, NUM_OF_SPECIAL_EVENT_DISPLAY)
    },
    eventOpenNow() {
      const today = timeConverter().dateTime
      return today.isSameOrAfter(this.event.start_at, 'day') && today.isSameOrBefore(this.event.end_at, 'day')
    },
    detailOrganizerMessageSection() {
      return this.event.detail.contents?.find(v => v.organizer_message && v.sections.length > 0)
    },
    supportLink() {
      if (this.isVbarEvent) return 'https://support.machicon.jp/hc/ja/requests/new?ticket_form_id=208718'
      return `https://support.machicon.jp/hc/ja/requests/new?ticket_form_id=360000000113&event=${this.event.title}`
    },
    inquiryLink() {
      if (this.isFiveMinutesEvent) return 'https://support.machicon.jp/hc/ja/categories/900000057166-5minutes'
      return 'https://support.machicon.jp/hc/ja/articles/900000172703'
    },
    eveOnlineSupportLink() {
      return 'https://support.machicon.jp/hc/ja/categories/900000156506'
    },
    faqLink() {
      return 'https://support.machicon.jp/hc/ja'
    },
    eventDefaultRequirementDescription2() {
      return this.event.default_requirement_description2
    },
    canDisplayNewInquiryDesign() {
      return this.event.place_phone_number || (!this.event.place_phone_number && !this.event.contact)
    },
    isCancelledEvent() {
      if (!this.event) return
      return this.event.status === 'cancelled'
    },
    canShowAddress() {
      return (
        !this.event.show_address_after_purchase ||
        (this.ticketInfo && !!this.ticketInfo.already_bought_purchase_id) ||
        this.pageDetector.isEventPreviewPage
      )
    },
    isForSale() {
      return this.event.sale_type === 'for_sale'
    },
    isBetweenStartDateAndEndDate() {
      return moment().isBetween(this.startAt.dateTime, this.endAt.dateTime, 'day', '[]')
    },
    femaleAgeRange() {
      return this.event.female_age_upper ? `${this.event.female_age_lower}〜${this.event.female_age_upper}歳` : `${this.event.female_age_lower}歳〜`
    },
    maleAgeRange() {
      return this.event.male_age_upper ? `${this.event.male_age_lower}〜${this.event.male_age_upper}歳` : `${this.event.male_age_lower}歳〜`
    },
    organizeDate() {
      if (this.onDuringDayEvent) return this.startAt.fullDateWithWeekDay
      return `${this.startAt.fullDateWithWeekDay}~${this.endAt.fullDateWithWeekDay}`
    },
    organizeTime() {
      if (this.isBarGourmetEvent) return this.onDuringDayEvent ? '' : `${this.startAt.timeShort}〜${this.endAt.timeShort}`
      return this.event.reception_start_at ? ` (受付開始 ${timeConverter(this.event.reception_start_at).timeShort})` : ''
    },
    organizeDateTime() {
      if (this.onDuringDayEvent) return `${this.startAt.fullDateWithWeekDayAndFormatHoliday} ${this.startAt.timeShort}〜${this.endAt.timeShort}`
      if (this.isBarGourmetEvent) return `${this.startAt.fullDateWithWeekDayAndFormatHoliday}〜${this.endAt.fullDateWithWeekDayAndFormatHoliday}`
      return `${this.startAt.fullDateWithWeekDayAndFormatHoliday} ${this.startAt.timeShort}〜 <br> ${this.endAt.fullDateWithWeekDayAndFormatHoliday} ${this.endAt.timeShort}`
    },
    advertisementPrice() {
      if (this.event.sale_type !== 'advertisement' || !this.event.advertising_male_price || !this.event.advertising_female_price) return ''
      return `男性${numberToCurrency(this.event.advertising_male_price)}　女性${numberToCurrency(this.event.advertising_female_price)}`
    },
    saleEndAt() {
      return timeConverter(this.event.sale_end_at).fullDateTimeWithWeekdayAndFormatHoliday
    },
    requirementText() {
      return this.event.requirements.map(req => {
        const eventReqText = { title: req.title, description: null }
        if (req.description && req.description.length > 0)
          eventReqText.description = req.description
            .trim()
            .split(/\n\r|\n/)
            .map(x => (x === '' ? '<br>' : x))
        return eventReqText
      })
    },
    cautionText() {
      return parseCautionText(this.event.caution_text)
    },
    prohibitionText() {
      return parseProhibitionText(this.event.prohibition_text)
    },
    externalUrl() {
      if (this.isCancelledEvent) return ''
      return this.event.external_site_url
    },
    showFloatFooter() {
      return (this.$store.isSP || this.$store.$state.window.scroll_top > 600) && !this.displayEventStatusFlashMessage
    },
    firstFlowTime() {
      const firstFlow = this.event.detail.flows ? this.event.detail.flows[0] : null
      if (!firstFlow) return ''
      return firstFlow.time_format
    },
    receptionFlowDescription() {
      if (!this.event.detail.flows) return ''
      const flow = this.event.detail.flows.filter(v => v.category === 'reception')
      return flow ? flow.description : ''
    },
    startFlowDescription() {
      if (!this.event.detail.flows) return ''
      const flow = this.event.detail.flows.filter(v => v.category === 'start')
      return flow ? flow.description : ''
    },
    // for menpass and konkatsu freepass
    purchaseStatus() {
      if (this.konkatsuFreepass && this.hasActiveKonkatsuFreepass) return 'active'
      if (this.mensPass && this.hasActiveMensPass) return 'active'
      if (this.onlineFitnessPass && this.hasActiveOnlineFitnessPass) return 'active'
      if (this.onlineCafetalkYogaPass && this.hasActiveOnlineCafetalkYogaPass) return 'active'
      if (this.konkatsuFreepass && this.hasPendingKonkatsuFreepassPurchases) return 'pending'
      if (this.mensPass && this.hasPendingMensPass) return 'pending'
      return ''
    },
    firstRowBreadCrumbOptions() {
      return this.generateBreadCrumbOptions('first')
    },
    secondRowBreadCrumbOptions() {
      return this.generateBreadCrumbOptions('second')
    },
    thirdRowBreadCrumbOptions() {
      return this.generateBreadCrumbOptions('third')
    },
    hidePurchaseButton() {
      if (this.isLotteryWating) return true
      return this.filteredTicketInfo.tickets && this.filteredTicketInfo.tickets.find(ticket => ticket.status === 'lottery_wating')
    },
    isOtherKonkatsuEvent() {
      return this.event.other_event_type === 'konkatsu'
    },
    eventTypeName() {
      const eventType = this.event.type
      // eventTypeがkonkatsuの時は'婚活パーティー'が欲しいため(getEventTypeNameだと'婚活パーティー・お見合いパーティー'になる)
      return eventType === 'konkatsu' ? '婚活パーティー' : EventModel.getEventTypeName(eventType)
    },
    commonHeaderClassNames() {
      return this.$store.isSP ? ['commonHeadingBlackSP', 'commonMargin', 'marginB2'] : ['textSmall', 'borderBottom', 'headingLarge']
    },
    countedGenderText() {
      const gender = this.numOfAccessedUsersInfo && this.numOfAccessedUsersInfo.counted_gender
      if (!gender || !UserModel.getGenderText(gender)) return ''
      return `の${UserModel.getGenderText(gender)}`
    },
    hasLargeText() {
      return this.displayNoticeMessageMode === 'accessCount' && this.hasLargeTextAccessCount
    },
    saleLimitText() {
      if (!this.displaySaleEnd) return ''
      const leftTimeMin = Math.floor(this.calcSaleLimitMs / 6e4)
      if (leftTimeMin < DISPLAY_SALE_ONE_HOUR_UPPER_LIMIT) return `${leftTimeMin}分`
      return leftTimeMin < DISPLAY_SALE_ONE_DAY_UPPER_LIMIT ? `${Math.floor(leftTimeMin / 60)}時間` : '1日'
    },
    displayAccessCount() {
      return this.numOfAccessedUsersInfo && this.numOfAccessedUsersInfo.access_count >= LOWER_BOUND_OF_DISPLAY_ACCESS_COUNT
    },
    displaySaleEnd() {
      return this.calcSaleLimitMs > DISPLAY_SALE_LIMIT_TIME_LOWER && this.calcSaleLimitMs < DISPLAY_SALE_LIMIT_TIME_UPPER
    },
    displayNoticeMessage() {
      return this.displayNoticeMessageMode === 'saleEnd' || this.displayNoticeMessageMode === 'accessCount'
    },
    calcSaleLimitMs() {
      if (!this.event.sale_end_at) return 0
      return new Date(this.event.sale_end_at) - new Date()
    },
    isPastEvent() {
      if (!this.event) return
      return moment().isAfter(this.event.end_at)
    },
    isOtoconOrganizerEvent() {
      return this.event.organizer_name === OTOCON_ORGANIZER_NAME
    },
    contactTextItem() {
      return this.pageDetector.isEventPreviewPage ? this.event.contact_text : this.contactText
    },
    openTimeItem() {
      return this.pageDetector.isEventPreviewPage ? this.event.opening_times : this.openingTimes
    },
    isMinorParticipantsContainingOfflineEvent() {
      if (this.isOnlineEvent) return false
      return this.event.female_age_lower < ADULTHOOD_AGE || this.event.male_age_lower < ADULTHOOD_AGE
    },
    bannerStamp() {
      if (!this.event) return
      if (!this.event.banner_stamp_type || this.event.banner_stamp_type === 'disactive') return null
      if (this.event.banner_stamp_type === 'sold_out_for_male' && (!this.maleTicket || this.maleTicket.stage_ticket_available_quantity !== 0))
        return null
      if (this.event.banner_stamp_type === 'sold_out_for_female' && (!this.femaleTicket || this.femaleTicket.stage_ticket_available_quantity !== 0))
        return null
      const params = this.event.banner_stamp_type === 'sold_to_people' ? { amount: this.event.banner_stamp_content } : {}
      const stampText = this.$useI18(`event.attributes.banner_stamp_type.${this.event.banner_stamp_type}`, params)
      return { class: ['orange'], text: stampText }
    },
    femaleTicket() {
      if (!this.ticketInfo.tickets) return null
      return this.ticketInfo.tickets.find(ticket => ticket.gender === 'female')
    },
    maleTicket() {
      if (!this.ticketInfo.tickets) return null
      return this.ticketInfo.tickets.find(ticket => ticket.gender === 'male')
    },
    canDisplayStageTicket() {
      return (this.femaleTicket && this.femaleTicket.original_stage_ticket_id) || (this.maleTicket && this.maleTicket.original_stage_ticket_id)
    },
    isPastEventFromOneMonth() {
      const oneMonthBefore = new Date(this.event.end_at)
      oneMonthBefore.setMonth(oneMonthBefore.getMonth() + 1)
      return moment().isAfter(oneMonthBefore)
    },
    hasPurchasedTicket() {
      return !!(this.ticketInfo && this.ticketInfo.already_bought_purchase_id)
    },
    endOfSaleAttention() {
      const endOfSaleAt = moment(this.event.sale_end_at || this.event.start_at)
      const diff = endOfSaleAt.diff(moment())
      const hour = diff / 36e5
      const min = diff / 6e4
      if (hour > 48 || hour < 0) return ''
      if (hour < 1) return min < 1 ? '' : `販売終了まで残り${Math.floor(min)}分`
      return hour < 24 ? `販売終了まで残り${Math.floor(hour)}時間` : '販売終了まで残り1日'
    },
    hasTicketSetSale() {
      return this.event.has_ticket_set_sale
    },
    groupDiscounts() {
      return this.ticketInfo.group_discounts
    },
    hasGroupID() {
      if (this.event.similar_group_id === undefined) return false
      return !this.event.similar_group_id.startsWith('no_group_')
    },
    noticeABTestFooterClass() {
      return NOTICE_VARIANTS[this.toastABTestBPattern ? 'b' : 'a']
    },
    eventDetailPageUIABTestBPattern() {
      const { isBPattern } = useABTestV2(SEARCH_AND_EVENT_DETAIL_AB_TEST_CONFIG)
      return isBPattern
    },
    detailFemaleQASection() {
      return this.event.detail?.contents?.find(v => v.female_qa && v.sections?.length > 0)
    },
    displayUserReviews() {
      return this.isFemalePage ? this.femaleUserReviews : this.userReviews
    },
    detailFemaleRecommend() {
      return this.event.detail.contents.find(v => v.female_recommend && v.sections.length > 0)
    },
    organizerEventsLink() {
      if (this.event && this.event.organizer_promoter_event_slug) {
        return `/promoters/${this.event.organizer_promoter_event_slug}`
      }
      return null
    },
    hasQualificationListItems() {
      return (
        ((this.event && this.event.address_requirement_description) ||
          (this.requirementText && this.requirementText.length > 0) ||
          (this.event && this.event.target_audience_description && this.event.is_external_event) ||
          this.isOtherKonkatsuEvent) &&
        !this.isScrapedOnlineEvent
      )
    }
  },
  created() {
    const { isAPattern, isBPattern } = useABTest(EVENT_DETAIL_TOAST_AB_TEST_CONFIG)
    this.toastABTestAPattern = isAPattern.value
    this.toastABTestBPattern = isBPattern.value
    if (!this.event) return

    // 対象外主催者の女性用URLアクセス時は404返す
    if (this.isFemalePage && !isFemalePageTarget(this.event.organizer_id)) {
      throw createError({ statusCode: 404, message: 'Not Found' })
    }

    if (['terminated', 'cancelled'].includes(this.event.status)) setResponseStatus(useRequestEvent(), 404)
    if (
      [
        import.meta.env.KONKATSU_FREEPASS_EVENT_CODE,
        import.meta.env.MENSPASS_EVENT_CODE,
        import.meta.env.ONLINE_FITNESS_PASS_EVENT_CODE,
        import.meta.env.ONLINE_CAFETALK_YOGA_PASS_EVENT_CODE
      ].includes(this.$route.params.code)
    )
      setPageLayout('simple')
    if (this.$route.query.auto_complete_ticket_id) this.requestLottery(`tickets/${this.$route.query.auto_complete_ticket_id}/waiting`)
    bus.$on('isLotteryWating', data => {
      this.isLotteryWating = data
    })
    this.$store.LAYOUT_DATA({ type: 'footer', data: { event_type: this.event.type } })
    if (import.meta.server && !this.konkatsuFreepass && !this.mensPass && !this.onlineCafetalkYogaPass) this.createJsonldToHead()
  },
  beforeUnmount() {
    bus.$off('isLotteryWating')
    this.$store.LAYOUT_DATA({ type: 'footer', data: { event_type: null } })
  },
  mounted() {
    this.getTicketInfo()
    this.fetchAccessCount()
    if (this.isPastEvent) this.getRecommendEventsForPastEvent()
    this.pushGtmDataWithEditQuery()

    // Send AB test event detail page view GA event
    this.sendOnEventDetailPageClick()

    if (this.$store.isLoggedIn && this.$route.query.contact_info === 'true') {
      const detailInfoEl = document.getElementById('detailInfo')
      const offsetTop = detailInfoEl.getBoundingClientRect().top
      const scrollTop = this.$store.isSP ? offsetTop - 40 : offsetTop - 200
      window.scrollTo({
        top: scrollTop,
        left: 0,
        behavior: 'smooth'
      })
    }
    const backUrl = window.history?.state?.back
    if (backUrl && typeof backUrl === 'string') {
      const isSearchComponentsPage = new PageDetector(useRouter().resolve(backUrl)).isSearchComponentsPage
      if (this.trackDetailView && this.event) {
        this.trackDetailView(this.event, isSearchComponentsPage)
      }

      // issue-434: 一覧経由での詳細画面遷移時のGAイベント発火
      const issue434Pattern = this.$store.$state.issue_434_ab_test_pattern
      if (issue434Pattern && isSearchComponentsPage) {
        GTM.sendEventToGa({
          category: 'issue',
          action: ISSUE_434_DETAIL_VIEW.action,
          label: issue434Pattern
        })
      }
    } else {
      if (this.trackDetailView && this.event) {
        this.trackDetailView(this.event, false)
      }
    }
  },
  methods: {
    changeAlternativeDateRecommendVersion(version) {
      this.alternativeDateRecommendVersion = version
    },
    changeRecommendVersionNew(version) {
      this.recommendVersionNew = version
    },
    checkAccessAccountBreakLine() {
      const accessCountBox = this.$refs.accessCount
      const noticeFooterBox = document.getElementsByClassName('noticeFooter')
      if (accessCountBox && noticeFooterBox.length > 0) this.hasLargeTextAccessCount = accessCountBox.offsetHeight > noticeFooterBox[0].offsetHeight
    },
    pushGtmDataWithEditQuery() {
      const query = { ...this.$route.query }
      const hash = this.$route.hash
      const onlineEventTypeQueryValue = ONLINE_EVENT_QUERY_VALUES[this.event.online_event_type]
      if (onlineEventTypeQueryValue) query.online_event_type = onlineEventTypeQueryValue

      // pushGtmData after replace
      this.$router
        .replace({ query, hash })
        .then(() => {
          this.pushGtmData()
        })
        .catch(() => {
          this.pushGtmData()
        })
    },
    requestLottery(apiUrl) {
      this.$store.dispatch('apiPost', apiUrl).then(res => {
        this.flashMessages.push({ type: 'success', message: res.data.message })
        this.isLotteryWating = true
        this.$nextTick(() => {
          scrollToTop()
        })
      })
    },
    fetchAccessCount() {
      if (this.pageDetector.isEventPreviewPage) return
      this.$store.dispatch('apiGet', `events/${this.$route.params.code}/access_count`).then(res => {
        this.numOfAccessedUsersInfo = res.data
        this.handleNoticeWindow()
        this.$nextTick(() => {
          this.checkAccessAccountBreakLine()
        })
      })
    },
    getRecommendEventsForPastEvent() {
      this.$store
        .dispatch('getRecommendEventsForPastEvent', {
          id: this.event.id,
          limit: MAX_RECOMMEND_EVENTS_FOR_PAST_EVENT
        })
        .then(res => {
          this.recommendEventsByArea = res.data.recommend_events_by_area.events || []
          this.recommendEventsByOrganizer = res.data.recommend_events_by_organizer.events || []
        })
    },
    pushGtmData() {
      if (this.event.sale_end_at) {
        GTM.pushData({ purchase_deadline: timeConverter(this.event.sale_end_at).format('YYYY-MM-DD HH:mm:ss') })
      }
      const prefecture = { id: this.event.prefecture_id, name: this.event.prefecture_name }
      const gtm = new GTM(this.$route, this.$store, { prefecture })
      GTM.pushData(gtm.defaultData)
      GTM.pushData({
        PageType: 'Productpage',
        HashedEmail: this.gtmDatalayer.hashed_email,
        ProductID: this.event.id,
        Ui_userlv: this.gtmDatalayer.ui_userlv
      })
      GTM.trackingPageView(this.$route)
      GTM.sendEcommerceDataToGa(GA4_VIEW_ITEM, this.event, this.$store.myGender, this.ticketInfo.tickets)
    },
    handleNoticeWindow() {
      if (this.displayNoticeMessageMode === null) {
        this.displayNoticeMessageMode = this.initNoticeMessageMode()
      } else if (this.displayNoticeMessageMode === 'saleEnd' && this.displayAccessCount) {
        this.displayNoticeMessageMode = 'accessCount'
      } else {
        this.displayNoticeMessageMode = 'completed'
      }

      if (this.displayNoticeMessage && !this.toastABTestBPattern) {
        setTimeout(this.handleNoticeWindow, DISPLAY_NOTICE_WINDOW_TIME)
      }
    },
    initNoticeMessageMode() {
      if (this.displaySaleEnd) return 'saleEnd'
      if (this.displayAccessCount) return 'accessCount'
      return 'completed'
    },
    linkify(text) {
      return linkifyHtml(text, { defaultProtocol: 'https' })
    },
    applyChangeBookmarkCount(num) {
      this.bookmarkedUserCount += num
    },
    isMatchAgeRangeToSendMessage() {
      if (!this.myBirthday || !this.$store.myGender) {
        return true
      }

      const eventAgeFrom = this.$store.myGender === 'male' ? this.event.male_age_lower : this.event.female_age_lower
      const eventAgeTo = this.$store.myGender === 'male' ? this.event.male_age_upper : this.event.female_age_upper
      const ageInEvent = moment(this.event.start_at).diff(this.myBirthday, 'years')
      return ageInEvent >= eventAgeFrom && (!eventAgeTo || eventAgeTo >= ageInEvent)
    },
    handleOpenContactInfoModal() {
      if (this.pageDetector.isEventPreviewPage) return
      if (!this.isMatchAgeRangeToSendMessage()) return alert(this.$useI18('event.messages.not_match_age_range', { userName: this.$store.myName }))
      if (this.$store.isLoggedIn) {
        this.$store.dispatch('apiGet', `events/${this.event.code}/check_event_contact_id`).then(response => {
          if (response.data.event_contact_id) {
            this.$router.push({ path: `/messages/${response.data.event_contact_id}` })
          } else {
            this.updateModalContact(MODAL_CONTACT)
            this.contactInfoModalOpenned = true
          }
        })
      } else {
        this.updateModalContact(MODAL_CONTENT)
        this.contactInfoModalOpenned = true
      }
    },
    updateModalContact(status) {
      this.modalContact = status
    },
    handleCloseContactInfoModal() {
      this.contactInfoModalOpenned = false
    },
    scrollToElement(targetElement, offset = 0) {
      const elementPosition = targetElement.getBoundingClientRect().top
      const scrollPosition = window.scrollY || document.documentElement.scrollTop
      window.scrollTo({
        top: elementPosition + scrollPosition + offset,
        behavior: 'instant'
      })
    },
    handleChangeEventTab(navigationTab) {
      const targetElement = document.getElementById(navigationTab)
      if (targetElement) {
        this.scrollToElement(targetElement)
        if (!this.hasDetailInfoTabClicked && navigationTab === 'detailInfo') {
          this.hasDetailInfoTabClicked = true
          setTimeout(() => {
            this.handleChangeEventTab(navigationTab)
          }, 100)
        }
      }
    },
    handleElementInView(tabKey) {
      if (tabKey in this.elementsInView) {
        this.elementsInView[tabKey] = true
      }
    },
    handleElementNotInView(tabKey) {
      if (tabKey in this.elementsInView) {
        this.elementsInView[tabKey] = false
      }
    },
    generateBreadCrumbOptions(rowNumber) {
      const commonOptions = {
        eventTitle: this.event.title,
        eventCode: this.eventCode,
        areaSlug: this.event.area_slug
      }
      if (rowNumber === 'first') {
        return {
          ...commonOptions,
          areaName: this.event.area_name,
          areaGroupSlug: this.event.area_group_slug,
          prefectureSlug: this.event.prefecture_slug,
          prefectureName: this.event.prefecture_name,
          regionName: this.event.region_name,
          regionSlug: this.event.region_slug,
          isFirstRow: true
        }
      }
      if (rowNumber === 'second') {
        return {
          ...commonOptions,
          eventType: this.event.type,
          haveInterest: this.event.have_interest,
          isGocon: this.event.gocon
        }
      }
      if (rowNumber === 'third') {
        return {
          ...commonOptions,
          featureTags: this.event.feature_tags,
          prefectureName: this.event.prefecture_name,
          prefectureSlug: this.event.prefecture_slug,
          isThirdRow: true
        }
      }
      return commonOptions
    },
    makeCall(number) {
      if (window) {
        window.location.href = `tel:${number}`
      }
    }
  },
  watch: {
    currentNavigationTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.previousNavigationTab = newVal
      }
    }
  }
})
</script>

<style scoped lang="scss">
.fadeOut {
  &-leave-active {
    transition: opacity 0.4s;
  }
  &-leave-to {
    opacity: 0;
  }
}

.fadeSlideRight {
  &-enter-active {
    transition:
      transform 0.6s 0.1s ease-out,
      opacity 0.6s 0.1s;
  }
  &-leave-active {
    transition: opacity 2s;
  }
  &-enter-from {
    opacity: 0;
    transform: translate(100%, 0);
  }
}

.fadeQuiq {
  &-enter-active,
  &-leave-active {
    transition: opacity 0.4s;
  }
  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}

:deep(.contentBlock) {
  padding: 20px 16px;

  @include pc {
    padding: 20px 0;
  }

  .contentBlock-info {
    padding: 1.6rem 0;
    color: $gray-55;
    font-size: 1.2rem;
  }
  .noticeForCovid19 {
    &-item {
      display: flex;
      text-align: center;
      &-image {
        width: 45%;
        max-width: 135px;
        margin-right: 5%;
        img {
          display: inline-block;
          justify-content: center;
          vertical-align: middle;
          width: 48%;
          height: 100%;
          margin: 0 auto;
          &:not(:last-child) {
            margin-right: 2%;
          }
        }
      }
      &-content {
        width: 59%;
        float: left;
        margin: auto auto auto 0;
        color: $gray-6a;
        line-height: 1.8;
        @include pc {
          width: auto;
        }
        &-note {
          font-size: 1rem;
        }
      }
      &:not(:last-child) {
        border-bottom: 1px solid $gray-c6;
        padding-bottom: 17px;
      }
      &:not(:first-child) {
        padding-top: 17px;
      }
    }
  }
}

.gotoEventBanner {
  padding: 5px;
  background-color: $red-bittersweet;
  text-align: center;
  color: $white;
  font-size: 1.2rem;
  font-weight: bold;
}

.eyecatch {
  position: relative;
  min-height: 118px;
  text-align: center;
  img {
    width: 100%;
    height: auto;
  }
}

.detailHead {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
  @include pc {
  }
  &-fixed {
    display: inline-block;
    background: #ebebeb;
    padding: 2.5px 8px;
    width: fit-content;
    border: 1px solid $gray-f7;
    border-radius: 3px;
    color: $gray-55;
    font-weight: bold;
  }
  &-title {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0;
    .title {
      font-size: 1.6rem;
      font-weight: bold;
    }
  }
  &-location {
    display: flex;
    justify-content: space-between;

    .locationInfo {
      width: 87%;

      font-weight: normal;
      font-size: 14px;
      color: #555555;

      &-dateTime {
        time {
          display: inline-flex;
        }
        display: inline-flex;
        font-weight: normal;
        &-date {
          font-size: 1.4rem;
        }
        &-time {
          font-size: 1.4rem;
          @include sp {
            display: block;
          }
        }
      }
    }
  }

  &-discount {
    display: inline-block;
    background: $pink-thin;
    padding: 2.5px 8px;
    margin: 1rem 0;
    width: fit-content;
    border: 1px solid $pink-thin;
    border-radius: 3px;
    color: $white;
    font-weight: bold;
  }
  &-group-discount {
    display: inline-block;
    background: $pink-thin;
    padding: 2.5px 8px;
    margin-bottom: 8px;
    width: fit-content;
    border: 1px solid $pink-thin;
    border-radius: 3px;
    color: $white;
    font-weight: bold;
  }
  &-status-row {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.externalLinkButton {
  height: 30px;
  border-radius: 8px;
  font-size: 1.2rem;
  justify-content: space-between;
  margin: 2rem 0 0;
  @include sp {
    margin: 2rem 1.6rem 0;
  }
  &-icon {
    float: left;
  }
  &-text {
    float: right;
    word-break: break-word;
  }
}

.preWrap {
  white-space: pre-wrap;
}

.end-of-sale-attention {
  font-weight: bold;
  font-size: 14px;
  color: #ea2e4b;
}

.simpleList {
  font-size: 1.4rem;
  color: $gray-55;

  &-item {
    @include negativeIndent;
    &.hasContent {
      &::before {
        content: '・';
      }
    }
  }
}

.prohibition-section {
  display: grid;
  grid-template-rows: repeat(4, auto);
}

.ruleTitle {
  font-weight: 700;
  color: $gray-55;
  padding-bottom: 4px;
  @include sp {
    font-size: 1.2rem;
  }
}

.rule-contact {
  padding-bottom: 16px;
  a {
    text-decoration: underline;
    color: $black-1a;
  }
}

.prohibition-list {
  padding-bottom: 16px;
}

.group-event {
  @include flex;
  width: 100%;
  padding: 0 16px;
  &-button {
    width: 100%;
    max-width: 470px;
  }
}

.addLineFriend {
  margin: 10px 6px;
}

.noticeText {
  color: $orange;
}

.additionText {
  margin-left: 1rem;
}

.socialLinks {
  &-item {
    display: inline-flex;
    height: 4rem;
    margin: 2rem 0.5rem 1rem 1rem;
    text-align: center;
    vertical-align: middle;
    width: calc(50% - 2rem);
    padding: 1.2rem;
    font-size: 1.2rem;
    font-weight: bold;
    &.mail,
    &.line {
      background-color: $gray-8e;
    }
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      color: $white;
    }
    &-text {
      margin-left: 0.5rem;
    }
  }
}

.organizerReview {
  @include sp {
    margin: 0 1.6rem;
  }
  a {
    margin: 25px auto;
    width: 100%;
    max-width: 336px;
  }
}

.prStamp {
  display: block;
  position: absolute;
  padding: 0 1rem;
  right: 0;
  background-color: $black-02;
  color: $gray-fa;
  z-index: 1;
}

.imgStamp {
  position: absolute;
  bottom: 10px;
  left: 4px;
  width: 60px;
  height: 60px;
  z-index: 1;
}

.contact {
  display: inline-block;
  background: none;
  text-decoration: underline;
  border: none;
  width: auto;
}

.inquiry {
  font-size: 1.2rem;
}

.commonTable {
  color: $gray-55;
  font-size: 1.4rem;
  border: none;
  th {
    font-weight: normal;
  }
  thead tr,
  tr:nth-of-type(2n) {
    background: none;
  }
  a {
    color: $black-1a;
    text-decoration: underline;
    word-break: break-all;
  }
  td {
    padding: 0 0 8px 0;
    &:first-child {
      /* 項目名 */
      font-weight: bold;
      width: var(--left-column-width);
    }
    &:last-child {
      padding-left: var(--column-gap);
      text-align: justify;
    }
  }
  tr:first-child {
    td {
      padding-top: 0;
    }
  }
  tr:last-child {
    td {
      padding-bottom: 0;
    }
  }
}

.bookmarkButton {
  display: flex;
  justify-content: center;
  align-items: center;
}

.commonMargin {
  margin-left: $spCommonMargin;
  margin-right: $spCommonMargin;
}

.contentBoxSp {
  background: $gray-f7;
  padding-top: 2rem;
  padding-bottom: 2.2rem;
}

.recommendEventsForPastEvent {
  :deep() {
    .scrollableBox {
      margin-bottom: 0;
    }
  }
}

.container {
  &-main {
    --left-column-width: 8.4rem;
    --column-gap: 31px;
    --line-gap: 16px;

    &-title {
      padding: 0.5rem 0;
      font-weight: bold;
      color: $white;
      &-content {
        line-clamp: 2;
        -webkit-line-clamp: 2;
      }
      @include sp {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &.center {
        padding: 0.4rem;
        text-align: center;
      }
      &.orange {
        background: $orange;
      }
    }
  }
}

@include sp {
  .container {
    margin-bottom: 0;
  }
  .breadcrumb {
    padding-top: 0.5rem;
    margin-left: 0.6rem;
    margin-right: 0.6rem;
  }
}

@keyframes fadeInWithDelay {
  0% {
    opacity: 0;
  }
  15% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.noticeFooterA {
  position: fixed;
  left: 3%;
  bottom: 73px;
  width: 94%;
  background-color: $black-269;
  border-radius: 4px;
  padding: 10px;
  font-size: 1.2rem;
  color: $white;
  z-index: 2;
  &.breakLinePadding {
    padding: 20px 10px;
  }
  &-noticeMessageA {
    width: 80%;
    bottom: 8px;
    left: 0;
    right: 0;
    margin-left: 10px;
    margin-bottom: 3px;
  }
  &-closeButtonA {
    z-index: 10;
    float: right;
    text-align: center;
    width: 14px;
    height: 14px;
    line-height: 14px;
    border-radius: 50%;
    color: $gray-55;
    background-color: $gray-c6;
  }
}

.noticeFooterB {
  position: fixed;
  left: 3%;
  bottom: 73px;
  width: 94%;
  background-color: $black-269;
  border-radius: 4px;
  padding: 16px;
  font-size: 1.4rem;
  font-weight: 400;
  color: $white;
  z-index: 2;
  animation: fadeInWithDelay 12s forwards;
  &.breakLinePadding {
    padding: 20px 10px;
  }
  &-noticeMessageB {
    width: 95%;
    bottom: 8px;
    left: 0;
    right: 0;
    margin-left: 10px;
    margin-bottom: 3px;
    animation: fadeInWithDelay 12s forwards;
  }
  &-closeButtonB {
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 10;
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    width: 18px;
    height: 18px;
    line-height: 18px;
    border-radius: 53px;
    color: $black-1a;
    background-color: $gray-cc;
  }
}

.noticeFooter {
  &-icon {
    z-index: 10;
    float: left;
    text-align: center;
    &.smallScreenIcon {
      margin-top: 5px;

      :deep(svg) {
        font-size: 2.5rem !important;
      }
    }
  }
  &.hidden {
    visibility: hidden;
  }
}

.disappear {
  opacity: 0;
  height: 0;
  overflow: hidden;
  padding: 0;
  margin: 0;
}

:deep() {
  .commonHeadingBlackSP,
  .commonHeadingBlack {
    margin-bottom: 1rem;
    font-size: 2rem;
    padding: 0 1.6rem;
  }
  .paddingL0 {
    padding-left: 0;
  }
  .recommendForPastEventHeading {
    font-size: 2rem;
    font-weight: 700;
    margin: 1rem 0;
    @include sp {
      margin: 1rem 1.6rem;
    }
  }
  .recommendEventsForPastEvent .scrollableBox-innerCustom .eventsList {
    gap: 1rem;
    & > li:first-child {
      margin-left: 1rem;
    }
  }
  @include sp {
    .contentBoxSp {
      .clMobileApps {
        margin-left: 0.6rem;
        margin-right: 0.6rem;
      }
      .serviceList {
        margin-left: $spCommonMargin;
        margin-right: $spCommonMargin;
      }
    }
    .eventsList {
      margin-left: $spCommonMargin;
    }
    .breadcrumb .breadcrumbList {
      margin-bottom: 0;
      margin-top: 0;
    }
    .commonSection .categoryList,
    .commonSection .bannerList {
      margin-left: $spCommonMargin;
      margin-right: $spCommonMargin;
    }
  }
  @include pc {
    .addLineFriend {
      padding: 0;
      margin-left: 0;
      margin-right: 0;
      margin-top: 0;
    }
    .commonSection.pcNoPaddingX {
      padding-left: 0;
      padding-right: 0;
    }
    .breadcrumb .breadcrumbList {
      margin: 0;
      width: 100%;
    }
    .commonHeadingBlackSP,
    .commonHeadingBlack {
      margin-bottom: 2rem;
      text-align: center;
    }
  }
}

.allowMultipleLines {
  white-space: pre-wrap;
}

.eventArea {
  display: inline-flex;
  font-weight: normal;
  &-name {
    min-width: 60px;
    display: inline-block;
    background: $gray-55;
    border-radius: 3px;
    padding: 0 0.6rem;
    vertical-align: middle;
    color: $white;
    font-size: 1.2rem;
    text-align: center;
    @include textEllipsis;
  }
}

.imageHeightAuto :deep(.eventsList-item-image img) {
  height: auto;
}

.flash-message {
  &-preview {
    display: flex;
  }
  .event-title {
    color: $gray-55;
  }
  .imgSmallSize {
    max-width: 22rem;
    min-width: 21rem;
    @include sp {
      max-width: 16rem;
      min-width: 15rem;
    }
    img {
      height: inherit;
      width: 100%;
      object-fit: contain;
      object-position: top;
      opacity: 0.5;
    }
  }
}

.grayBg {
  background-color: $gray-f7;
}

.commonSection {
  margin-bottom: 4rem;
  @include pc {
    margin-bottom: 5rem;
  }
  .commonSectionHeading {
    font-size: 2rem;
    margin-bottom: 2rem;
    padding: 0 1.6rem;
    @include pc {
      text-align: center;
    }
  }
}

.marginY0 {
  margin-top: 0;
  margin-bottom: 0;
}

.eventCustomBox {
  padding-top: 2rem;
  padding-bottom: 6rem;
  @include pc {
    padding-top: 2rem;
    padding-bottom: 7rem;
  }
}

.customizeEventSize :deep() {
  @include sp {
    .scrollableBox-inner {
      .eventsList {
        width: 100%;
      }
    }
  }
  .eventsList-item.simpleItem {
    width: 100%;
    @include pc {
      width: 29.5rem;
    }
    padding: 1.5rem;
    .eventsList-item-banner-image {
      height: 13.5rem;
      img {
        aspect-ratio: 16/7;
        height: 13rem;
        max-height: fit-content;
      }
    }
    .eventsList-item-simple {
      margin-top: 1rem;
    }
  }
}

.detailTable {
  table {
    line-height: 1.6;

    tr {
      td:first-child {
        color: $black-1a;
      }
      td {
        padding-bottom: var(--line-gap);
      }
    }
  }

  &-contact {
    td:last-child {
      padding-left: 0;
    }
    &-container {
      display: flex;
      flex-direction: column;
      text-align: center;
    }
    &-contactButton {
      width: 100%;
    }
    &-detail {
      width: 100%;
    }
    &-link {
      color: $gray-55;
    }
  }
}

.tabListWrapper {
  margin: 1rem 0;
  position: sticky;
  top: $pcHeaderHeight;
  z-index: 2;
  @include sp {
    top: $spHeaderHeight;
  }
  .tabList {
    width: inherit;
    padding: 0;
    border-bottom: 2px solid $cerulean-blue;
    &-item {
      margin: unset;
      border-bottom: 1px solid $cerulean-blue;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      color: $black-1a;
      padding: 0;
    }
  }
}

:deep() {
  .scrollableBox-innerCustom {
    position: relative;
  }
  .scrollableBox-innerCustom h2 {
    text-align: start;
  }
  .scrollableBox-innerCustom .scrollableBox.enableScroll .scrollableBox-inner {
    margin: unset;
    .forScrollEvent {
      width: 0;
    }
  }
}

.male-label {
  color: $blue-thin-light;
}

.female-label {
  color: $pink-hot;
}

.male-label,
.female-label {
  font-weight: 700;
}

.participating-qualifications {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 16px;

  @include pc {
    padding: revert;
  }
}

.age-range-qualification {
  display: flex;
  gap: 16px;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 1.6rem;
}

.qualification__male-label {
  color: $blue-thin-light;
}

.qualification__female-label {
  color: $pink-hot;
}

.qualification__gender-label {
  font-weight: 700;
  display: flex;
  gap: 4px;
}

.age-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  gap: 8px;
}

.age-row dt {
  font-weight: bold;
}

.age-text {
  display: flex;
}

.align-bottom-text {
  align-self: flex-end;
  display: inline-flex;
  line-height: 1;
}

.qualification-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.qualification-list-item {
  display: flex;
  flex-direction: column;
  gap: 4px;

  dt {
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1;
  }

  dd {
    font-size: 1.4rem;
    color: $base-light;
    line-height: 1.6;
  }
}

.event-requirement-alert {
  display: flex;
  align-items: center;
  background: $foundation-warning-light;
  border-radius: 8px;
  padding: 16px;
  gap: 8px;

  .event-requirement-alert-text {
    color: $black-1a;
    font-size: 1.4rem;
    line-height: 1.6;
    word-break: break-word;
    flex: 1;
    display: flex;
    align-items: center;
  }
}

.organizer {
  padding: 2rem 1.6rem;

  display: grid;
  grid-template-columns: var(--left-column-width) 1fr;
  row-gap: var(--line-gap);
  column-gap: var(--column-gap);

  @include pc {
    padding: 2rem 0;
  }
}

.organizer-info {
  width: 100%;
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;
  row-gap: var(--line-gap);
}

.organizer-image {
  grid-column: span 2;
  width: 100%;
}

.organizer-details {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: span 2;
  row-gap: var(--line-gap);
  line-height: 1.6;

  dt {
    font-weight: bold;
  }
}

.organizer-contact {
  grid-column: span 2;
  display: flex;
  flex-direction: column;
  gap: var(--line-gap);
}

.contact-buttons {
  display: flex;
  gap: 1rem;

  button {
    display: flex;
    gap: 1rem;
    flex-grow: 1;
    flex-basis: 0;
    flex-shrink: 1;
  }
}

.inquiry {
  line-height: 1.6rem;
}

.user-reviews {
  grid-column: span 2;
  display: flex;
  flex-direction: column;
  gap: var(--line-gap);
}

.user-reviews-title {
  font-weight: bold;
  color: $black-1a;
  font-size: 16px;
}

.organizer-message {
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;

  h3 {
    font-size: 14px;
    font-weight: bold;
    word-break: keep-all;
  }
}

.event-eyecatch {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.locationInfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.eventArea {
  margin-right: 10px;
  border-right: 1px solid #ccc;
  padding-right: 10px;
}

.detailHead-wrapper {
  padding-right: 16px;
  padding-left: 16px;
  padding-top: 8px;

  @include pc {
    padding-right: 8px;
    padding-left: 8px;
  }
}

:deep(.event-detail-heading) {
  padding: 48px 0 8px;
  margin: 0 16px;
  border-bottom: 2px solid $blue-sky-f8;
  font-size: 20px;

  &.event-detail-application-status {
    padding-top: 32px;
  }

  @include pc {
    margin: 0;
  }
}

.organizerEvents {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  &-header {
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    @include pc {
      font-size: 20px;
    }
  }
  .recommendPC {
    @include flex;
    justify-content: left;

    &.scrollable {
      display: flex;
      flex-wrap: nowrap;
      gap: 1rem;

      .recommendPC-item {
        flex-shrink: 0;
        width: 22rem;
      }
    }
  }
}

.organizerEvents-moreButtonWrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  .commonButton {
    flex: 1 1 0;
    max-width: 336px;
  }
}

.participation-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
